import axios from 'axios';
import { getOptions, getOptionsNew } from '../../auth/authUtil';
import handleErrors from '../apiEroor/ErrorHandler';
import { useDispatch, useSelector } from 'react-redux';
import { setTotalRecords } from '../../redux/reducer/totalRecordSlice';

const baseUrl = process.env.REACT_APP_API_ENDPOINT;

//.......custom Hook...........
export const useApi = () => {
    const dispatch = useDispatch();
    //const store = useSelector(state => state);
    //console.log("API handler, store : ", store);

    const getUseRequest = async (url, data, navigate) => {

        try {
            const response = await axios(baseUrl + url, getOptions('GET', data));
            dispatch(setTotalRecords(response?.headers["x-total-count"]))
            return response.data;
        } catch (error) {
            if (error.response) {
                let errMsg = handleErrors(error.response.status, navigate);
                throw errMsg;
            } else if (error.request) {
                const errorMessage = handleErrors(0, navigate);
                throw errorMessage;
            } else {
                throw error.message;
            }
        }
    };

    return { getUseRequest };
}

// Normal Function.....
const getRequest = async (url, data, navigate) => {
    try {
        const response = await axios(baseUrl + url, getOptions('GET', data));
        return response.data;
    } catch (error) {
        if (error.response) {
            let errMsg = handleErrors(error.response.status, navigate);
            throw errMsg;
        } else if (error.request) {
            const errorMessage = handleErrors(0, navigate);
            throw errorMessage;
        } else {
            throw error.message;
        }
    }
};


export const postRequest = async (url, data, navigate) => {
    try {
        const response = await axios(baseUrl + url, getOptions('POST', data));
        return response;
    } catch (error) {
        if (error.response) {
            let errMsg = handleErrors(error.response.status, navigate);
            throw errMsg;
        } else if (error.request) {
            const errorMessage = handleErrors(0, navigate);
            throw errorMessage;
        } else {
            throw error.message;
        }
    }
}

export const putRequest = async (url, data, navigate) => {
    try {
        const response = await axios(baseUrl + url, getOptions('PUT', data));
        return response;
    } catch (error) {
        if (error.response) {
            let errMsg = handleErrors(error.response.status, navigate);
            throw errMsg;
        } else if (error.request) {
            const errorMessage = handleErrors(0, navigate);
            throw errorMessage;
        } else {
            throw error.message;
        }
    }
};

export const patchRequest = async (url, data, navigate) => {
    try {
        const response = await axios(baseUrl + url, getOptions('PATCH', data));
        return response;
    } catch (error) {
        if (error.response) {
            let errMsg = handleErrors(error.response.status, navigate);
            throw errMsg;
        } else if (error.request) {
            const errorMessage = handleErrors(0, navigate);
            throw errorMessage;
        } else {
            throw error.message;
        }
    }
};


export const deleteRequest = async (url, data, navigate) => {
    try {
        const response = await axios(baseUrl + url, getOptions('DELETE', data));
        return response.data;
    } catch (error) {
        if (error.response) {
            let errMsg = handleErrors(error.response.status, navigate);
            throw errMsg;
        } else if (error.request) {
            const errorMessage = handleErrors(0, navigate);
            throw errorMessage;
        } else {
            throw error.message;
        }
    }
};

export default getRequest;